import { HttpParams } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ComponentConfig, InputType } from 'dg-input-lib';
import { tap } from 'rxjs/operators';
import { CaseView } from '../../models/caseview.model';
import { SelectCaseDialogComponent } from '../actions/selectCaseDialog/select-case-dialog.component';
import { WorktrayService } from '../worktray/Service/worktray.service';
import { SendWithinHeirarchyService } from './send-within-heirarchy.service';
export class customData {
  selectedData: CaseView[];
  isFromCustomAction: boolean;
}
@Component({
  selector: 'app-send-within-heirarchy',
  templateUrl: './send-within-heirarchy.component.html',
  styleUrls: ['./send-within-heirarchy.component.scss'],
})
export class SendWithinHeirarchyComponent implements OnInit {
  rows = [];
  cols = [];
  caseData: any = [];
  recepComboItemsMap = {};
  refIdList = '';
  sendData: any;
  recId = [];
  actionId: any;
  showTable: boolean = false;
  isRowContainsGrpType = false;
  selectedUnit: any;
  dataSource: any;
  header: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private sendHierarchyService: SendWithinHeirarchyService,
    public translate: TranslateService,
    private dialogRef: MatDialogRef<SendWithinHeirarchyComponent>,
    private worktayService: WorktrayService
  ) {}

  ngAfterViewInit(): void {
    this.refreshCols();
    this.setGrid();
    this.rows = [...this.rows];
  }

  setGrid(): void {
    this.caseData = [];
    this.caseData = this.data['data'];
    this.actionId = this.caseData[0]?.actionId;
    let refIdList: string = '';
    let recId = [];
    for (const s of this.caseData) {
      refIdList += String(s.docId) + ',';
      recId.push(s.docId);
    }
    refIdList = refIdList.slice(0, -1);
    if (this.data?.isFromCustomAction) {
      this.setHierarchyData(this.data?.withinHierarchyData);
    } else {
      let params = new HttpParams();
      params = params.append('appTypeId', '1');
      params = params.append('refId', refIdList);
      params = params.append('actionId', this.actionId);
      params = params.append('recNo', refIdList);
      if (this.actionId === '660') {
        params = params.append('organizationId', this.caseData[0]?.orgId);
      }
      this.sendHierarchyService
        .hierarchyDtls(params)
        .subscribe((res: { data }) => {
          this.setHierarchyData(res);
        });
    }
  }

  setHierarchyData(res): void {
    const restemp: { data } = res;
    this.showTable = true;
    let SENDER_DATA: any[] = [];
    let singleData = {
      docId: null,
      alphanum_Fileno: null,
      process: null,
      recipient: [],
      selectedRadio: null,
      showMsg: false,
    };
    if (!restemp.data.length) {
      singleData.recipient.push({
        empName: 'No person is mapped above you',
        unitId: 0,
      });
      singleData.showMsg = true;
    } else {
      singleData.showMsg = false;
      for (const val of this.caseData) {
        singleData.alphanum_Fileno = val.docNo;
        singleData.process = val.subject;
        singleData.docId = val.docId;
        for (const s of restemp.data) {
          if (s.recId == val.docId) {
            let fileH: any = s.fileHierarchyVOArr;
            if (!fileH || fileH.length === 0) {
              singleData.recipient.push({ empName: s.msg, unitId: 0 });
              singleData.showMsg = true;
            } else {
              let tempComboItems = [];
              fileH = this.sortHierarchyDataByName(fileH);
              for (const m of fileH) {
                const recep = {
                  empName: m.empName,
                  empId: m.empId,
                  unitId: m.unitId,
                  unitName: m.unitName,
                  toOrderNo: m.unitLevel,
                  mpgType: m.mpgTyp,
                  roleId: m.nextRole,
                  subHrchyLvlPk: m.subHrchyLvlPk,
                };
                if (m.mpgTyp.toString() === '658') {
                  this.isRowContainsGrpType = true;
                }

                if (!recep.empName) {
                } else {
                  singleData.recipient.push(recep);
                  tempComboItems.push(recep);
                }
              }
              this.recepComboItemsMap[val.docId] = tempComboItems;
            }
          }
        }
        SENDER_DATA.push(singleData);
        singleData = {
          docId: null,
          alphanum_Fileno: null,
          process: null,
          recipient: [],
          selectedRadio: null,
          showMsg: false,
        };
      }
    }
    this.rows = SENDER_DATA;
    this.isRowContainsGrpType = this.changeIsRowContainsGrpTypeValueBasedOnFromCustomAction();

    this.rows.forEach((row) => {
      let selectedData = null;
      if (this.recepComboItemsMap[row.docId]?.length === 1) {
        selectedData = this.recepComboItemsMap[row.docId][0];
        row.selectedRadio = selectedData;
      }
      row = this.setCustomItemsInRow(
        row,
        'recepient',
        this.isRowContainsGrpType ? 'Group Trays' : 'Recepient',
        this.recepComboItemsMap,
        'recepOutput',
        selectedData
      );
      if (this.isRowContainsGrpType) {
        if (selectedData) {
          this.getAllMappedEmpByGrp(
            selectedData?.unitId,
            selectedData?.toOrderNo,
            selectedData?.subHrchyLvlPk,
            row,
            false,
            -1
          );
          console.log('row', row);
        } else {
          row = this.setCustomItemsInRow(
            row,
            'recepientUnit',
            this.translate.instant('withinHierarchyDialog.recepientUnit'),
            [],
            'recepOutput',
            null
          );
        }
      }
    });
    this.rows = [...this.rows];

    this.refreshCols(this.isRowContainsGrpType);
  }

  changeIsRowContainsGrpTypeValueBasedOnFromCustomAction(): any {
    if (this.isRowContainsGrpType) {
      this.isRowContainsGrpType = this.data?.showUnitsOptionFlag;
    } else {
      this.isRowContainsGrpType = false;
    }
    return this.isRowContainsGrpType;
  }

  setCustomItemsInRow(row, key, columnName, items, output, selectedData): any {
    try {
      row[key] = {};
    } catch (e) {
      row = { ...row, [key]: {} };
    }
    row[key].cellConfig = {
      columnId: key,
      columnName: columnName,
      configAtRowLevel: true,
      width: 100,
      type: InputType.CUSTOM_TYPE,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      searchable: false,
      displayable: true,
    };
    row[key].cellConfig.renderComponent = new ComponentConfig();
    row[key].cellConfig.renderComponent.componentAddress = RecepComboComponent;
    row[key].cellConfig.renderComponent.componentOutputs = {
      recepOutput: (event) => {},
    };
    row[key].cellConfig.renderComponent.componentOutputIdsValue = [output];
    row[key].cellConfig.component = new ComponentConfig();
    row[key].cellConfig.component.componentAddress = RecepComboComponent;
    row = this.setInputsForCustomComponent(row, key, items, selectedData);
    row[key].cellConfig.component.componentOutputs = {
      recepOutput: (event) => {},
    };
    row[key].cellConfig.component.componentOutputIdsValue = [output];
    return row;
  }

  setInputsForCustomComponent(row, key, items, selectedData): any {
    row[key].cellConfig.renderComponent.componentInputs = {
      recepComboItemsMap: items,
      rowData: row,
      selectedData: selectedData,
    };
    row[key].cellConfig.component.componentInputs = {
      recepComboItemsMap: items,
      rowData: row,
      selectedData: selectedData,
    };
    return row;
  }

  ngOnInit(): void {
    console.log(this.data)
    
  }
  getHeader()
  {
    if(Number(this.data.data[0].actionId)==610)
    {
      return "Forward One Level Above"
    }
    else
    {
      return "Send in Same Level"
    }
  }
  refreshCols(isRowContainsGrpType: boolean = false): void {
    let tempFlag = false;
    this.sendHierarchyService.onSetConfigurableFields?.subscribe((res) => {
      if (res) {
        if (
          this.sendHierarchyService?.configurableFields?.[
            'hideProcessNameAndFileNoInSendCase'
          ]
            ?.toString()
            ?.trim()
            ?.toLowerCase() === 'true'
        ) {
          tempFlag = true;
        }
        this.cols = [
          {
            columnName: isRowContainsGrpType ? 'Group Trays' : 'Recipient',
            columnId: 'recepient',
            width: 100,
            type: InputType.CUSTOM_TYPE,
            headerAlign: 'center',
            align: 'center',
            displayable: true,
            configAtRowLevel: true,
            component: {
              componentAddress: RecepComboComponent,
              componentOutputs: {
                recepOutput: (event) => {},
              },
              componentOutputIdsValue: ['recepOutput'],
            },
            renderComponent: {
              componentAddress: RecepComboComponent,
              componentOutputs: {
                recepOutput: (event) => {},
              },
              componentOutputIdsValue: ['recepOutput'],
            },
          },
        ];

        if (!tempFlag) {
          this.cols = [
            {
              columnName: 'File No.',
              columnId: 'alphanum_Fileno',
              width: 150,
              type: null,
              headerAlign: 'center',
              align: 'center',
              displayable: true,
            },
            {
              columnName: 'Process',
              columnId: 'process',
              width: 120,
              type: null,
              headerAlign: 'center',
              align: 'center',
              displayable: true,
            },
            ...this.cols,
          ];
        }

        if (isRowContainsGrpType) {
          this.cols = [
            ...this.cols,
            {
              columnName: this.translate.instant(
                'withinHierarchyDialog.recepientUnit'
              ),
              columnId: 'recepientUnit',
              width: 120,
              type: InputType.CUSTOM_TYPE,
              headerAlign: 'center',
              align: 'center',
              displayable: true,
              configAtRowLevel: true,
              component: {
                componentAddress: RecepComboComponent,
                componentOutputs: {
                  recepOutput: (event) => {},
                },
                componentOutputIdsValue: ['recepOutput'],
              },
              renderComponent: {
                componentAddress: RecepComboComponent,
                componentOutputs: {
                  recepOutput: (event) => {},
                },
                componentOutputIdsValue: ['recepOutput'],
              },
            },
          ];
        }

        this.cols = [...this.cols];
      }
    });
    if (this.sendHierarchyService.configurableFields) {
      this.sendHierarchyService.onSetConfigurableFields.next(true);
    } else {
      this.sendHierarchyService.setConfigurableFields();
    }
  }

  onCustomOutput({ rowIndex, row, customComponentOutput, col, form }): void {
    customComponentOutput.forEach((output: { from: string; data: any }) => {
      if (output.from === 'recepOutput') {
        if (this.isRowContainsGrpType) {
          if (output.data?.mpgType?.toString() === '658') {
            this.getAllMappedEmpByGrp(
              output.data?.unitId,
              output?.data?.toOrderNo,
              output?.data?.subHrchyLvlPk,
              row,
              true,
              rowIndex
            );
            row.selectedRadio = output?.data;
            //this.rows[rowIndex].selectedRadio = output?.data;
          } else if (output.data == null) {
            if (col?.columnId === 'recepient') {
              row.selectedRadio = output?.data;
              row.selectedRadioUnit = output?.data;
              //this.rows[rowIndex].selectedRadio = output?.data;
              //this.rows[rowIndex].selectedRadioUnit = output?.data;
              row = this.setInputsForCustomComponent(
                row,
                'recepientUnit',
                [],
                null
              );
            } else {
              row.selectedRadioUnit = output?.data;
              //this.rows[rowIndex].selectedRadioUnit = output?.data;
            }
          } else if (output.data?.mpgType?.toString() === '656') {
            if (col?.columnId === 'recepient') {
              row.selectedRadio = output?.data;
              row = this.setInputsForCustomComponent(
                row,
                'recepientUnit',
                [],
                null
              );
            } else {
              row.selectedRadioUnit = output?.data;
            }

            //this.rows[rowIndex].selectedRadioUnit = output?.data;
          }
        } else {
          row.selectedRadio = output?.data;
          //this.rows[rowIndex].selectedRadio = output?.data;
        }
        this.rows[rowIndex] = row;
        this.rows = [...this.rows];
      }
    });
    this.rows = [...this.rows];
  }

  getAllMappedEmpByGrp(grpId, toOrderNo, subHrchyLvlPk, row, flag, rowIndex) {
    this.worktayService?.getAllMappedEmployees(grpId)?.subscribe((res) => {
      let temp = [];
      res?.data?.forEach((unit) => {
        if (
          unit?.wlRoleId?.toString()?.trim() !==
          this.data?.data[0]?.fileOwnerUnit?.toString()?.trim()
        ) {
          temp.push({
            empName:
              unit?.empName +
              ' (' +
              unit?.unitName +
              ')' +
              ' (' +
              unit?.empEmailId +
              ')',
            empId: unit?.empId,
            unitId: unit?.wlRoleId,
            unitName: unit?.unitName,
            toOrderNo: toOrderNo,
            mpgType: '656',
            roleId: null,
            subHrchyLvlPk: subHrchyLvlPk,
          });
        }
      });
      let unitList = { [row?.docId]: temp };

      let selectedData = null;
      if (unitList[row.docId]?.length === 1) {
        selectedData = unitList[row.docId][0];
      }

      if (row?.recepientUnit?.cellConfig) {
        row = this.setInputsForCustomComponent(
          row,
          'recepientUnit',
          unitList,
          selectedData
        );
      } else {
        row = this.setCustomItemsInRow(
          row,
          'recepientUnit',
          this.translate.instant('withinHierarchyDialog.recepientUnit'),
          unitList,
          'recepOutput',
          selectedData
        );
      }
      if (flag) {
        this.rows[rowIndex] = row;
        this.rows = [...this.rows];
      } else {
        this.rows[rowIndex] = row;
        this.rows = [...this.rows];
      }
    });
  }

  onSend(): void {
    let flag = 0;
    let postData = {
      refId: [],
      toOrderNo: [],
      roleId: [],
      toMpgType: [],
      toUnit: [],
      applTypeId: 1,
      toGrpId: null,
      toType: null,
      movmentActionFlag: 4,
      subHrhcyLvlPk: null,
      pullToWorklistUnit: null,
    };
    for (const s of this.rows) {
      postData.refId.push(Number(s.docId));
      if (!s.selectedRadio) {
        flag++;
      } else {
        postData.applTypeId = this.caseData[0]?.appTypeId === '3' ? 3 : 1;
        postData.toUnit.push(s.selectedRadio.unitId);
        postData.toOrderNo.push(s.selectedRadio?.toOrderNo);
        postData.toMpgType.push(s.selectedRadio?.mpgType);
        postData.subHrhcyLvlPk = s.selectedRadio?.subHrchyLvlPk;
        if (s.selectedRadio?.mpgType === 657) {
          postData.roleId.push(s.selectedRadio?.roleId);
        } else {
          postData.roleId.push(-1);
        }
        if (s.selectedRadio?.mpgType === 658) {
          postData.toGrpId = s.selectedRadio?.unitId;
          postData.toType = 1970;

          postData.pullToWorklistUnit = s.selectedRadioUnit;
        }
      }
    }

    if (flag) {
      this.dialog.open(SelectCaseDialogComponent, {
        data: this.translate.instant('send_Within.PleaseSelect'),
      });
    } else {
      if (!this.data?.isFromCustomAction) {
        this.sendHierarchyService.sendWorkFlow(postData).subscribe(
          (res) => {
            this.dialogRef.close(true);
          },
          (error) => {
            this.dialogRef.close(false);
          }
        );
      } else {
        this.dialogRef.close(postData);
      }
    }
  }
  handleChange(event, actionName): void {
    console.log('on radio change', event);
    event.value.actionType = actionName;
    this.selectedUnit = event?.value;
  }

  isButtonDisable(): boolean {
    const hasUnselectedRecipient = this.rows.some((s) => !s.selectedRadio);

    return hasUnselectedRecipient;
  }

  sortHierarchyDataByName(hierarchyArr): any {
    for (let i = 0; i < hierarchyArr?.length; i++) {
      for (let j = i + 1; j < hierarchyArr.length; j++) {
        if (hierarchyArr[i]?.empName > hierarchyArr[j]?.empName) {
          let temp = hierarchyArr[i];
          hierarchyArr[i] = hierarchyArr[j];
          hierarchyArr[j] = temp;
        }
      }
    }

    return hierarchyArr;
  }
}
@Component({
  template: `<div>
      <ng-select
        [items]="recepComboItemsMap?.[rowData?.docId]"
        bindLabel="empName"
        appendTo="body"
        [multiple]="false"
        [formControl]="recepName"
      ></ng-select>
    </div>
    <ng-template *ngIf="recepName$ | async"></ng-template> `,
})
export class RecepComboComponent implements OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
    this.recepName.setValue(this.selectedData);
  }
  @Input() recepComboItemsMap = {};
  @Input() rowData;
  @Input() selectedData = null;
  @Output() recepOutput = new EventEmitter();
  recepName = new FormControl(null);
  recepName$ = this.recepName.valueChanges.pipe(
    tap((value: any) => {
      this.recepOutput.emit(value);
    })
  );
}
